import { formatDistance } from 'date-fns';
import {
  getInProgressVisitorCount,
  getInProgressCountRetrievedTimestamp,
} from 'modules/workflows/ducks';
import { useSelector } from 'react-redux';
import { spacing, colors, body2, caption } from 'ui/theme';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const IN_PROGRESS_CARD_TEST_ID = 'in-progress-card';
export const IN_PROGRESS_COUNT_TEST_ID = 'in-progress-count';

const InProgressContainter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.threeEights};
  align-self: stretch;
  margin: 0 0 ${spacing.base} 0;
`;

const InProgressRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.threeEights};
  align-self: stretch;
  justify-content: space-between;
`;
const CardText = styled.div`
  color: ${colors.textPrimary};
  ${body2};
`;

const CardValue = styled.div`
     ${body2}
     font-size: ${pxToRem(14)}; 
     color: ${colors.textPrimary};
     text-align: right;
     font-variant-numeric: lining-nums tabular-nums;
`;
const CardDateTime = styled.div`
  ${colors.textSecondary};
  ${caption}
`;

export const InProgressCard = () => {
  const inProgressCount = useSelector(getInProgressVisitorCount) ?? 0;
  const inProgressCountRetrievedTimestamp = useSelector(getInProgressCountRetrievedTimestamp);

  return (
    <InProgressContainter data-test={IN_PROGRESS_CARD_TEST_ID}>
      <InProgressRow>
        <CardText>Currently in journey:</CardText>
        <CardValue data-test={IN_PROGRESS_COUNT_TEST_ID}>
          {inProgressCount.toLocaleString()}
        </CardValue>
      </InProgressRow>
      {inProgressCountRetrievedTimestamp && (
        <CardDateTime>
          As of {formatDistance(inProgressCountRetrievedTimestamp, new Date(), { addSuffix: true })}
        </CardDateTime>
      )}
    </InProgressContainter>
  );
};
